<template>
<v-container fluid class="recover-page">
    <v-row justify="center" class="py-6">
      <v-col cols="12" md="10" lg="8">
        <v-card class="auth-card rounded-xl overflow-hidden" elevation="8">
          <v-row no-gutters>
            <v-col cols="12" md="4" class="quick-links-panel pa-8 d-flex flex-column justify-center">
              <v-icon size="44" class="mb-3 white--text">mdi-shield-key-outline</v-icon>
              <div class="text-overline font-weight-bold white--text">MYSCH</div>
              <div class="text-h5 font-weight-bold white--text mb-2">Account Recovery</div>
              <div class="text-body-2 white--text recover-blurb">
                Forgot your password? No worries — we'll send a reset code to your registered email address.
              </div>
            </v-col>

            <v-col cols="12" md="8">
              <v-card-text class="pa-8 pa-md-10">
                <div class="text-overline font-weight-bold accent--text">SECURITY</div>
                <div class="text-h5 font-weight-bold mb-1">Reset your password</div>
                <div class="text-body-2 grey--text mb-6">
                    Enter your Email address and a Reset CODE will be emailed to you in approx. 5 minutes time
                </div>

                <v-form
                    v-if="nextScreen == false"
                >
                    <v-row>
                        <v-col md="12">
                            <v-text-field
                            v-model="email"
                            :counter="50"
                            outlined
                            :rules="[ v => /.+@.+\..+/.test(v) || 'E-mail must be valid']"
                            label="E-mail Address"
                            prepend-inner-icon="mdi-email-outline"
                            required
                            ></v-text-field>
                        </v-col>
                        <v-col md="12">
                            <v-btn
                            color="primary"
                            large
                            rounded
                            elevation="2"
                            class="font-weight-bold text-none"
                            @click="sendToken"
                            >
                            Send Reset Token
                            <v-icon right>mdi-arrow-right</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
                <v-form
                    v-else
                >
                    <v-row>
                        <v-col md="6" cols="12">
                            <v-text-field
                            v-model="form.password"
                            :counter="15"
                            outlined
                            :rules="passwordRules"
                            label="New Password"
                            type="password"
                            prepend-inner-icon="mdi-lock-outline"
                            required
                            ></v-text-field>
                        </v-col>
                        <v-col md="6" cols="12">
                            <v-text-field
                            v-model="form.password_confirmation"
                            :counter="15"
                            outlined
                            :rules="passwordRules"
                            label="Re-enter New Password"
                            type="password"
                            prepend-inner-icon="mdi-lock-check-outline"
                            required
                            ></v-text-field>
                        </v-col>
                        <v-col md="12">
                            <v-text-field
                            v-model="form.token"
                            :counter="4"
                            outlined
                            :rules="numberRules"
                            label="Password Token"
                            prepend-inner-icon="mdi-shield-key-outline"
                            required
                            ></v-text-field>
                        </v-col>
                        <v-col md="12">
                            <v-btn
                            color="primary"
                            large
                            rounded
                            elevation="2"
                            class="font-weight-bold text-none mr-3"
                            @click="updatePassword"
                            >
                            Update Password
                            <v-icon right>mdi-arrow-right</v-icon>
                            </v-btn>
                            <v-btn
                            text
                            class="text-none"
                            @click="nextScreen = false"
                            >
                            Restart Recovery Process
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
  export default {
    name: 'RecoverPassword',
    mounted() {
       if (this.authToken) {
            this.$router.push({name: 'ModuleSelector'})
       }
    },
    data: () => ({
        authToken:sessionStorage.getItem('authToken') ?? null,
        token:null,
        email: null,
        form: {},
        nextScreen: false,
        passwordRules: [
            v => !!v || 'Password is required',
            v => (v && v.length >= 8) || 'Password must not be less than 8 characters',
        ],
        numberRules: [
            v => !!v || 'Password Token is required',
            v => (v && v.length == 4) || 'Code must be 4 digits',
        ],
    }),
    methods: {
        updatePassword () {
            let loader = this.$loading.show()
            axios.post(process.env.VUE_APP_AUTHURL+'/password/reset?email='+this.email,this.form,
            {
                headers:
                    {
                        'Device-Referrer-Id': process.env.VUE_APP_DEVICEID,
                        'X-Auth-Source': 'school',
                    }
            })
            .then((response) => {
                this.$toast.success(response.data.message, {
                    timeout: 5000
                });
                this.nextScreen = false
                this.$router.push({name: 'Login'})
            })
            .catch((error) => {
                console.log(error.response)
                this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                    timeout: 5000
                });
            })
            .finally(() => {
                loader.hide()
            });
        },
        sendToken () {
            let loader = this.$loading.show()
            axios.post(process.env.VUE_APP_AUTHURL+'/password/recovery?email='+this.email,
            {},
            {
                headers:
                    {
                        'Device-Referrer-Id': process.env.VUE_APP_DEVICEID,
                        'X-Auth-Source': 'school',
                    }
            })
            .then((response) => {
                this.$toast.success(response.data.message, {
                    timeout: 5000
                });
            })
            .catch((error) => {
                this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                    timeout: 5000
                });
            })
            .finally(() => {
                loader.hide()
                this.nextScreen = true
            });
        },
    },
  }
</script>

<style scoped>
.recover-page {
    min-height: calc(100vh - 64px);
}
.quick-links-panel {
    background: linear-gradient(180deg, #1E3C72 0%, #142A52 100%);
    min-height: 100%;
}
.recover-blurb {
    opacity: 0.85;
    max-width: 320px;
}
</style>
